module.exports = __webpack_public_path__ + "img/mauritius.4383fa4c.svg";